/* eslint-disable no-use-before-define */
// React
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSwipeable } from 'react-swipeable';
import { getPostHomepage } from 'api/services/wp';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CircleIcon from '@mui/icons-material/Circle';
import JuntsButton from 'modules/website/shared/components/JuntsButton';
import formatDate from 'utils/formatDate';
import htmlEntDecoder from 'utils/htmlEntDecoder';
import { uniqueId } from 'lodash';
import { useAnimate } from 'framer-motion';
import './SliderNoticies.scss';
import { featuredImageFallBack } from 'modules/website/shared/constants';
import { Fade } from 'react-awesome-reveal';

function SliderNoticies() {
  const [noticies, setNoticies] = useState(null);
  const [index, setIndex] = useState(0);
  const [currentItem, setCurrentItem] = useState(null);
  const container = useRef(null);
  const sliderContent = useRef(null);
  const [_, animate] = useAnimate();

  useEffect(() => {
    getPostHomepage().then(({ data }) => {
      setNoticies(data);
      setCurrentItem(data[0]);
    });
  }, []);

  useEffect(() => {
    if (noticies && container.current) {
      const backgroundImage =
        currentItem?._embedded?.['wp:featuredmedia']?.[0]?.source_url || featuredImageFallBack;
      container.current.style.background = `url(${backgroundImage}) no-repeat center center`;

      setCurrentItem(noticies[index]);
    }
  }, [index, currentItem, noticies, container.current]);

  useEffect(() => {
    if (container.current) {
      const animation = async () => {
        animate(container.current, { opacity: [0, 1] }, { duration: 1.5 });
        animate(sliderContent.current, { opacity: [0, 1] }, { duration: 1.5 });
      };

      animation();
    }
  }, [index, animate, container]);

  useEffect(() => {
    const timeout = setTimeout(() => handleSlider('next'), 5000);

    return () => clearTimeout(timeout);
  }, [noticies, index]);

  function handleSlider(action) {
    if (action === 'next') {
      if (index === noticies.length - 1) {
        setIndex(0);
      } else {
        setIndex(index + 1);
      }
    } else if (action === 'previous') {
      if (index === 0) {
        setIndex(noticies.length - 1);
      } else {
        setIndex(index - 1);
      }
    }
  }

  const handlers = useSwipeable({
    onSwipedRight: () => handleSlider('next'),
    onSwipedLeft: () => handleSlider('previous'),
  });

  return (
    <Fade triggerOnce>
      <div style={{ background: '#27535c' }}>
        <div className="slidernoticies__container" {...handlers}>
          {currentItem && (
            <>
              <ArrowBackIosIcon
                className="slidernoticies--arrow slidernoticies--arrow-left"
                onClick={() => handleSlider('previous')}
              />
              <ArrowForwardIosIcon
                className="slidernoticies--arrow slidernoticies--arrow-right"
                onClick={() => handleSlider('next')}
              />

              <div className="slidernoticies__inner">
                <div className="slidernoticies__left">
                  <div className="slidernoticies__content" ref={sliderContent}>
                    <h2 className="slidernoticies__content--title">
                      {htmlEntDecoder(currentItem.title.rendered)}
                    </h2>

                    <h2 className="slidernoticies__content--date">
                      {formatDate(currentItem.date)}
                    </h2>

                    <div className="slidernoticies__content--button">
                      <Link to={`actualitat/${currentItem.slug}`}>
                        <JuntsButton color="blue">Llegeix la notícia</JuntsButton>
                      </Link>
                    </div>

                    <div className="slidernoticies__circles">
                      {noticies.map((_, key) => (
                        <CircleIcon
                          key={uniqueId('slidernoticies__circles--mobile-')}
                          className="slidernoticies__circles-icon circles-mobile"
                          style={{ color: index === key ? '#00c3b2' : '' }}
                          onClick={() => setIndex(key)}
                        />
                      ))}
                    </div>
                  </div>
                </div>

                <div className="slidernoticies__right" ref={container}>
                  <div className="slidernoticies__right--layout" />
                  <div className="slidernoticies__circles">
                    {noticies.map((_, key) => (
                      <CircleIcon
                        key={uniqueId('slidernoticies__circles--desktop-')}
                        className="slidernoticies__circles-icon circles-desktop"
                        style={{ color: index === key ? '#00c3b2' : '' }}
                        onClick={() => setIndex(key)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </Fade>
  );
}

export default SliderNoticies;
